module.exports = __webpack_public_path__ + "img/linked-accounts.fa324994.png";